import { useEffect } from 'react';
import { APP_NAME, DOCUMENT_TITLE_SEPARATOR } from '@constants/app';

/**
 * Sets `document.title` to "<title> · <APP_NAME>" while the calling component
 * is mounted, restoring the previous title on unmount. An empty title falls
 * back to APP_NAME alone. Client-only SPA — no SSR guard needed.
 */
const useDocumentTitle = (title: string, withSuffix = true): void => {
	const composed = !title
		? APP_NAME
		: withSuffix
			? `${title}${DOCUMENT_TITLE_SEPARATOR}${APP_NAME}`
			: title;

	useEffect(() => {
		const previous = document.title;
		document.title = composed;

		return () => {
			document.title = previous;
		};
	}, [composed]);
};

export default useDocumentTitle;
